import $ from 'jquery';

function TableYearSelectorInit() {
  var selector = '.table-year-select';
  $(document).on('change', selector, function () {
    var url = $(this).val();
    // var url = $(this).attr("data-url") + '/' + v;
    location.href = url;
  });
}

$(document).ready(function () {
  console.log("frontend: table ready");

  TableYearSelectorInit();
});
